// ============================================================================
// Form Config: CustomPages
// Key: customPages
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import type { FormSection } from '@/shared/forms/GenericForm'
import { enumFormOptions } from '../../entity-config-runtime/entity-form-config'
import { CustomPageIcon, LinkTarget } from '../api/backstage.schemas'
// #endregion

// #region Create Form
export const customPagesCreateFormConfig: FormSection[] = [
	{
		title: 'forms_custom_pages_create_section_main',
		fields: [
			{
				name: 'displayName',
				label: 'forms_custom_pages_create_display_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'description',
				label: 'forms_custom_pages_create_description',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'url',
				label: 'forms_custom_pages_create_url',
				type: 'url' as const,
				initialValue: '',
			},
			{
				name: 'icon',
				label: 'forms_custom_pages_create_icon',
				type: 'icon' as const,
				options: enumFormOptions(CustomPageIcon, 'CustomPageIcon'),
				initialValue: '',
			},
			{
				name: 'enabledForAllUsers',
				label: 'forms_custom_pages_create_enabled_for_all_users',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'sortOrder',
				label: 'forms_custom_pages_create_sort_order',
				type: 'number' as const,
				initialValue: 0,
			},
			{
				name: 'linkTarget',
				label: 'forms_custom_pages_create_link_target',
				type: 'select' as const,
				options: enumFormOptions(LinkTarget, 'LinkTarget'),
				allowEmpty: false,
				initialValue: 'NEWTAB',
			},
			{
				name: 'iFrameWidth',
				label: 'forms_custom_pages_create_i_frame_width',
				type: 'number' as const,
				initialValue: 0,
			},
		],
	},
]
// #endregion

// #region Edit Form
export const customPagesEditFormConfig: FormSection[] = [
	{
		title: 'forms_custom_pages_edit_section_main',
		fields: [
			{
				name: 'displayName',
				label: 'forms_custom_pages_edit_display_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'description',
				label: 'forms_custom_pages_edit_description',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'url',
				label: 'forms_custom_pages_edit_url',
				type: 'url' as const,
				initialValue: '',
			},
			{
				name: 'icon',
				label: 'forms_custom_pages_edit_icon',
				type: 'icon' as const,
				options: enumFormOptions(CustomPageIcon, 'CustomPageIcon'),
				initialValue: '',
			},
			{
				name: 'enabledForAllUsers',
				label: 'forms_custom_pages_edit_enabled_for_all_users',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'sortOrder',
				label: 'forms_custom_pages_edit_sort_order',
				type: 'number' as const,
				initialValue: 0,
			},
			{
				name: 'linkTarget',
				label: 'forms_custom_pages_edit_link_target',
				type: 'select' as const,
				options: enumFormOptions(LinkTarget, 'LinkTarget'),
				allowEmpty: false,
				initialValue: 'NEWTAB',
			},
			{
				name: 'iFrameWidth',
				label: 'forms_custom_pages_edit_i_frame_width',
				type: 'number' as const,
				initialValue: 0,
			},
		],
	},
]
// #endregion

// #region Forms Config Export
export const customPagesFormsConfig = {
	create: customPagesCreateFormConfig,
	edit: customPagesEditFormConfig,
} as const
// #endregion
